module.exports = __webpack_public_path__ + "img/markPoint8.0a40ffd2.png";